<template>
  <InfoCard>
    <template slot="header">
      <img class="icon" src="files/lidl/images/new-icons/svg/guthaben.svg" />
    </template>
    <template slot="body">
      <p class="text-xl">Mein Guthaben</p>
      <p class="text-2xl">
        <strong>{{ formattedBalance }}</strong>
      </p>
    </template>
    <template slot="footer">
      <a :href="topUpLink" class="button button--primary">
        Guthaben aufladen
      </a>
    </template>
  </InfoCard>
</template>
<script>
import InfoCard from '@/components-v2/flows/LIDL/Overview/InfoCard.vue'
import transaction from '@/mixins/transaction'
import price from '@/mixins/price'
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'

export default {
  name: 'BalanceInfoCard',
  mixins: [transaction('balanceInfo'), price],
  components: {
    InfoCard
  },
  data() {
    return {
      currentCustomer: {
        balance: null,
        contract: {
          msisdn: ''
        }
      }
    }
  },
  apollo: {
    currentCustomer: function() {
      return wrapQuery(
        gql`
          query balanceInfo {
            currentCustomer {
              balance
              contract {
                msisdn
              }
            }
          }
        `,
        this,
        'currentCustomer'
      )
    }
  },
  computed: {
    formattedBalance() {
      if (this.currentCustomer.balance === null) {
        return '-'
      }
      return this.price(this.currentCustomer.balance)
    }
  },
  props: {
    topUpLink: {
      type: String,
      default: '/mein-lidl-connect-v2/uebersicht.html#topUpAmount'
    }
  }
}
</script>
